import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Button, Stack } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { observer } from 'mobx-react'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useIntl } from 'react-intl'
import z from 'zod'
import CustomAccordion from '../../../../../components/customElements/RequestDataAccordions/utils/CustomAccordion'
import { useFileLoader } from '../../../../../hooks/useFileLoader'
import { useInvalidateQueries } from '../../../../../hooks/useInvalidateQueries'
import { markOrderAsUncompleted } from '../../../../../services/ApiService'
import { notifySuccess } from '../../../../../services/ToastifyService/ToastifyService'
import { checkUploadedImages } from '../../../../SingleRequestPage/components/SingleRequestDrawer/content/DrawerContentInstallation'
import FormInput from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'
import { RequestType } from '../../../../SingleRequestPage/types/Request.type'
import { newRequestDrawerStore } from '../../../stores/NewRequestDrawerStore'
import NewPhotosUpload from '../../InstalationRequestDrawer/components/NewPhotosUpload'

const toReworkNewSchema = z.object({
  comment: z.string().refine((val) => !!val.trim()),
})

type ToReworkNewForm = z.infer<typeof toReworkNewSchema>

interface ToReworkNewProps {
  request: RequestType
}

const ToReworkNew: React.FC<ToReworkNewProps> = ({ request }) => {
  const intl = useIntl()
  const invalidate = useInvalidateQueries()
  const { files, handleSetFiles, deleteFile, photoPermission } =
    useFileLoader('uncompleted')

  const {
    control,
    formState: { isValid },
    watch,
  } = useForm<ToReworkNewForm>({
    mode: 'onChange',
    defaultValues: {
      comment: '',
    },
    resolver: zodResolver(toReworkNewSchema),
  })

  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['send-to-rework'],
    mutationFn: () =>
      markOrderAsUncompleted({
        orderId: request.id,
        comment: watch('comment'),
        ...files?.map((file) => file.file),
      }),
    onSuccess: (data) => {
      const result = checkUploadedImages(data)
      if (result) {
        newRequestDrawerStore.onBack()
        newRequestDrawerStore.updateRequest(data)
        invalidate([
          'requests-table',
          'get-request-images',
          'get-request-comments',
        ])
        notifySuccess('Заявка обновлена')
      }
    },
  })

  return (
    <Stack gap={'24px'}>
      <Stack>
        {/* @ts-ignore */}
        <CustomAccordion
          defaultOpenState
          summary={'Фотографии перевода в статус "На доработку"'}
        >
          <NewPhotosUpload
            request={request}
            photoSettings={photoPermission}
            title={intl.formatMessage(
              {
                id: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
                defaultMessage: `Загрузите от {minimumLimit} до {maximumLimit} фотографий`,
              },
              {
                minimumLimit: photoPermission?.minLimitPerLoad,
                maximumLimit: photoPermission?.maxLimitPerLoad,
              },
            )}
            collection={files ?? []}
            setFile={handleSetFiles}
            deleteFile={deleteFile}
          />
        </CustomAccordion>
        {/* @ts-ignore */}
        <CustomAccordion
          defaultOpenState
          summary={'Причина перевода в статус "На доработку"'}
        >
          <FormInput
            control={control}
            fullWidth
            name='comment'
            label={''}
            placeholder='Заполните причину перевода'
            multiline
            rows={3}
          />
        </CustomAccordion>
      </Stack>
      <Box px={'16px'}>
        <Button
          variant='contained'
          onClick={() => mutateAsync()}
          loading={isPending}
          disabled={!isValid}
          fullWidth
        >
          Вернуть на доработку
        </Button>
      </Box>
    </Stack>
  )
}

export default observer(ToReworkNew)
